import { useState } from "react";
import { Mail } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export const NewsletterField = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Enter a valid email.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      setDone(true);
      if (data.duplicate) toast.info("You're already subscribed.");
      else toast.success("You're in. Welcome to the list.");
    } catch (err) {
      toast.error("Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <p
        className="text-sm text-jow-gold mt-3"
        data-testid="newsletter-success"
      >
        Thank you. The list awaits.
      </p>
    );
  }

  return (
    <form
      onSubmit={submit}
      className="mt-3 flex items-center border border-jow-cream/25 focus-within:border-jow-gold transition-colors"
      data-testid="newsletter-form"
    >
      <Mail size={14} className="ml-3 text-jow-gold shrink-0" />
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.in"
        className="bg-transparent flex-1 px-3 py-3 text-sm text-jow-cream placeholder:text-jow-cream/40 outline-none"
        data-testid="newsletter-input"
      />
      <button
        type="submit"
        disabled={loading}
        className="bg-jow-gold text-jow-navy font-sans text-xs uppercase tracking-widest px-4 py-3 hover:brightness-95 disabled:opacity-60"
        data-testid="newsletter-submit"
      >
        {loading ? "…" : "Join"}
      </button>
    </form>
  );
};
